import React from 'react';

import { Trans } from '@lingui/macro';

import { BREAKPOINTS, disabledColor } from '@zego/theme';

import RegularText from '@zego/components/atoms/RegularText';
import View from '@zego/components/atoms/View';
import ContentContainer from '@zego/components/ContentContainer';
import Link from '@zego/components/Link';

import BusinessInsider from './assets/high/BI.svg';
import EveningStandard from './assets/high/ES.png';
import EsAdnDelSeguro from './assets/high/EsAdnDelSeguro.png';
import EsElPais from './assets/high/EsElPais.svg';
import TechCrunch from './assets/high/TC.svg';

const ES_MARKETING_LIST = [
  {
    to:
      'http://uk.businessinsider.com/zego-startup-ex-deliveroo-employees-pay-as-you-go-insurance-gig-economy-workers-2017-7',
    title:
      'Un startup fundado por ex-trabajadores de Deliveroo ha bajado las barreras del seguro para mensajeros y repartidores  - artículo en Business Insider',
    img: (
      <img
        css={{ width: 120, height: 39 }}
        src={BusinessInsider}
        alt="Logo Business Insider"
      />
    ),
  },
  {
    to:
      'https://adndelseguro.com/actualidad/mercado/los-3-motivos-por-los-que-un-repartidor-en-moto-debe-tener-un-seguro-profesional/',
    title:
      'Los 3 motivos por los que un repartidor en moto debe tener un seguro profesional',
    img: (
      <img
        css={{ width: 150, height: 25 }}
        src={EsAdnDelSeguro}
        alt="Logo ADN Del Seguro"
      />
    ),
  },
  {
    to: 'https://techcrunch.com/2017/11/18/zego/',
    title:
      'Zego se lleva £6M en su Seria A con Balderton por su seguro para la economía colaborativa - artículo en Techcrunch',
    img: (
      <img
        css={{ width: 152, height: 22 }}
        src={TechCrunch}
        alt="Logo TechCrunch"
      />
    ),
  },
  {
    to:
      'https://retina.elpais.com/retina/2019/01/02/innovacion/1546431479_929457.html',
    title:
      'Cinco preguntas clave (y dos pistas) para entender el futuro del trabajo.',
    img: (
      <img
        css={{ width: 150, height: 35 }}
        src={EsElPais}
        alt="Logo El Pais"
      />
    ),
  },
];

const GB_MARKETING_LIST = [
  {
    to:
      'http://uk.businessinsider.com/zego-startup-ex-deliveroo-employees-pay-as-you-go-insurance-gig-economy-workers-2017-7',
    title:
      'A startup founded by ex-Deliveroo employees thinks it has solved a costly problem for couriers - article on Business Insider',
    img: (
      <img
        css={{ width: 120, height: 39 }}
        src={BusinessInsider}
        alt="Business Insider logo"
      />
    ),
  },
  {
    to:
      'https://www.standard.co.uk/business/gig-economy-insurance-startup-zego-raises-12m-a3591286.html',
    title:
      'Gig economy insurance start-up Zego raises £1.2m - article on Evening Standard',
    img: (
      <img
        css={{ width: 148, height: 18 }}
        src={EveningStandard}
        alt="Evening Standard logo"
      />
    ),
  },
  {
    to: 'https://techcrunch.com/2017/11/18/zego/',
    title:
      'Zego picks up £6M Series A led by Balderton for its gig economy worker insurance - article on Techcrunch',
    img: (
      <img
        css={{ width: 152, height: 22 }}
        src={TechCrunch}
        alt="TechCrunch logo"
      />
    ),
  },
];

const getMarketingListByCountry = country => {
  switch (country) {
    case 'es':
      return ES_MARKETING_LIST;
    default:
      return GB_MARKETING_LIST;
  }
};

const Marketing = ({ backgroundColor = disabledColor(2), country = 'gb' }) => (
  <View css={{ backgroundColor }}>
    <ContentContainer>
      <View
        css={{
          padding: 32,
          [BREAKPOINTS.contentContainer]: {
            padding: 72,
            paddingTop: 0,
          },
        }}
      >
        <RegularText
          css={{
            color: disabledColor(7),
            fontSize: 12,
            textAlign: 'center',
            textTransform: 'uppercase',
            letterSpacing: 1.71,
            paddingTop: 32,
            [BREAKPOINTS.medium]: {
              paddingTop: 48,
            },
          }}
        >
          <Trans id="Marketing / Title">As featured in</Trans>
        </RegularText>
        <View
          css={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'space-around',
            alignItems: 'center',
            marginBottom: -16,
          }}
        >
          {getMarketingListByCountry(country).map((m, i) => (
            <Link
              css={{ margin: 32 }}
              key={i}
              href={m.to}
              title={m.title}
              target="_blank"
              rel="noopener noreferrer"
            >
              {m.img}
            </Link>
          ))}
        </View>
      </View>
    </ContentContainer>
  </View>
);

export default Marketing;
